import { render, staticRenderFns } from "./base-icon.vue?vue&type=template&id=b8214cf2&scoped=true&"
import script from "./base-icon.vue?vue&type=script&lang=js&"
export * from "./base-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8214cf2",
  null
  
)

export default component.exports